module.exports = __webpack_public_path__ + "f21ccd85e97d0b0325868985fdcba4ad.png";